import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, Briefcase, Mail, Phone } from 'lucide-react';
import employeeApi from '../../lib/employeeApi';
import EmployeeLayout from '../../components/EmployeeLayout';

export default function TeamMemberDetailPage() {
  const { employeeId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await employeeApi.get(`/api/employees/${employeeId}/details`);
        setData(res.data);
      } catch (error) {
        toast.error('Failed to load');
      }
    };
    fetchData();
  }, [employeeId]);

  if (!data) return <EmployeeLayout><div className="p-8 text-center">Loading...</div></EmployeeLayout>;

  return (
    <EmployeeLayout>
      <div className="p-8">
        <Link to="/employee/team" className="inline-flex items-center text-charcoal-600 hover:text-pink-600 mb-6"><ArrowLeft className="w-4 h-4 mr-2" />Back to Team</Link>
        
        <div className="bg-white rounded-xl border border-charcoal-200 p-8 mb-6">
          <h1 className="text-3xl font-bold text-charcoal-900 mb-4">{data.employee.personal?.full_name || data.employee.work_email}</h1>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <p className="text-charcoal-600">Employee ID</p>
              <p className="font-medium text-charcoal-900">{data.employee.employment?.employee_id}</p>
            </div>
            <div>
              <p className="text-charcoal-600">Designation</p>
              <p className="font-medium text-charcoal-900">{data.employee.employment?.designation}</p>
            </div>
            <div>
              <p className="text-charcoal-600">Department</p>
              <p className="font-medium text-charcoal-900">{data.employee.employment?.department}</p>
            </div>
            <div>
              <p className="text-charcoal-600">Email</p>
              <p className="font-medium text-charcoal-900">{data.employee.work_email}</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl border border-charcoal-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-charcoal-900">Tasks</h3>
            <span className="text-sm text-charcoal-600">{data.task_count} total</span>
          </div>
          <div className="space-y-3">
            {data.tasks.map(task => (
              <div key={task._id} className="p-4 bg-charcoal-50 rounded-xl">
                <p className="font-medium text-charcoal-900">{task.title}</p>
                <p className="text-sm text-charcoal-600 mt-1">{task.task_type} • {task.department}</p>
                <div className="flex gap-2 mt-2">
                  <span className={`px-2 py-1 rounded-xl text-xs ${task.priority === 'critical' ? 'bg-red-100 text-red-700' : task.priority === 'high' ? 'bg-orange-100 text-orange-700' : 'bg-charcoal-100 text-charcoal-700'}`}>{task.priority}</span>
                  <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-xl text-xs">{task.status}</span>
                  {task.due_date && <span className="px-2 py-1 bg-pink-100 text-pink-700 rounded-xl text-xs">Due: {task.due_date}</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </EmployeeLayout>
  );
}